export default {"src":"/_next/static/media/Ollie_Site_Icons_working_final_CanineCouncil.c91f77cb.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};